import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app.material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BusinessRulesRoutingModule } from './business-rules-routing.module';
import {BusinessRulesComponent} from "./business-rules.component";
import {BusinessRuleViewComponent} from "../business-rule-view/business-rule-view.component";

@NgModule({
    imports: [
        CommonModule,
        BusinessRulesRoutingModule,
        AppMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [
        BusinessRulesComponent,
        BusinessRuleViewComponent
    ],
})
export class BusinessRulesModule { }